import { Form, FormInstance, Input, Popover } from "antd";
import React from "react";
import { mobileRegExp, v2VirtualMobileRegExp, v1VirtualMobileRegExp } from "@/utils/RegExp";
import { ConsigneeInfoFormValues } from "./ConsigneeInfoForm/type";

interface MobileFormItemProps {
    privacyProtection: boolean;
}

export function getMobileValidate(form: FormInstance<ConsigneeInfoFormValues>) {
    return {
        validator() {
            const { telephone, mobile } = form.getFieldsValue();

            if (!telephone && !mobile) {
                return Promise.reject("手机和电话必须填一个");
            }

            if (
                mobile &&
                !mobileRegExp.test(mobile) &&
                !v1VirtualMobileRegExp.test(mobile) &&
                !v2VirtualMobileRegExp.test(mobile)
            ) {
                return Promise.reject("请输入有效的手机号码");
            }

            return Promise.resolve();
        },
    };
}

const MobileFormItem: React.FC<MobileFormItemProps> = function (props) {
    const { privacyProtection } = props;

    const mobileFormItem = (
        <Form.Item label="手机" name="mobile" rules={[getMobileValidate]} className="ml10" dependencies={["telephone"]}>
            <Input style={{ width: 120 }} size="small" />
        </Form.Item>
    );

    return (
        <Form.Item noStyle shouldUpdate>
            {(form: FormInstance<ConsigneeInfoFormValues>) => {
                const { mobile } = form.getFieldsValue();
                const showTip = mobile && v1VirtualMobileRegExp.test(mobile);

                if (showTip) {
                    return (
                        <Popover
                            open
                            content={
                                <div className="error" style={{ width: 550 }}>
                                    录入虚拟号后，为正常获取单号，保存订单时发货易会转换成固定格式(例如：姓名[xxxx]，详细地址[xxxx])。软件不承担因录入错误的虚拟号导致快递配送错误造成的损失
                                </div>
                            }
                        >
                            {mobileFormItem}
                        </Popover>
                    );
                }

                if (privacyProtection) {
                    return <Popover content={<span className="error">原号码为虚拟号</span>}>{mobileFormItem}</Popover>;
                }

                return mobileFormItem;
            }}
        </Form.Item>
    );
};

export default React.memo(MobileFormItem);
